'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Dictionary = require('./classes/Dictionary');

var _Dictionary2 = _interopRequireDefault(_Dictionary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _Dictionary2.default({
  ASSET_PURCHASE: 'Asset Purchase',
  HEDGE_FUND: 'Hedge Fund',
  PRIVATE_EQUITY: 'Private Equity',
  COMMON_EQUITY: 'Common Equity',
  PREFERRED_EQUITY: 'Preferred Equity',
  PREFERRED_EQUITY_GP_LP: 'Preferred Equity (GP/LP structure)',
  PREFERRED_EQUITY_CONTROL: 'Preferred Equity (Direct investment) – Control',
  PREFERRED_EQUITY_NON_CONTROL: 'Preferred Equity (Direct investment) – Non-control',
  CONVERTIBLE_PREFERRED_EQUITY: 'Convertible Preferred Equity',
  REVENUE_PARTICIPATION: 'Revenue Participation',
  STRAIGHT_DEBT: 'Straight Debt (Yield)',
  HYBRID: 'Hybrid (Mezzanine)',
  DPP_VPP: 'DPP / VPP',
  DRILLCO: 'DrillCo Structure',
  SAFE: 'SAFE',
  CONVERTIBLE_NOTE: 'Convertible Note',
  SAFT_CONVERTIBLE_NOTE: 'SAFE or Convertible Note',
  SECURITY_TOKEN: 'Security Token',
  DIGITAL_SECURITY: 'Digital Security',
  DIGITAL_ASSET: 'Digital Asset',
  DIRECT_PARTICIPATION_PROGRAM: 'Direct Participation Program',
  CONVERTIBLE_PROMISSORY_NOTE: 'Convertible Promissory Note',
  CONVERTIBLE_DEBT: 'Convertible Debt',
  EXCHANGEABLE_DEBT: 'Exchangeable Debt',
  MEZZANINE_DEBT: 'Mezzanine Debt',
  SECOND_LIEN_DEBT: 'Second Lien Debt',
  SENIOR_DEBT: 'Senior Debt',
  SENIOR_SECURED_DEBT: 'Senior Secured Debt',
  SUBORDINATED_DEBT: 'Subordinated Debt',
  PIPE: 'Private Investment in Public Equity (PIPE)',
  STOCK: 'Stock',
  SECURED_NOTES: 'Secured Notes',
  TERM_LOAN_A: 'Term Loan A',
  TERM_LOAN_B: 'Term Loan B',
  DEBENTURES: 'Debentures',
  PROJECT_FINANCING: 'Project financing',
  STRUCTURED_FINANCING: 'Structured financing',
  WARRANTS: 'Warrants',
  SWAP: 'Swap',
  FUND_UI_LP: 'Fund unit interests - limited partner (LP)',
  FUND_UI_LLC: 'Fund unit interests - LLC member',
  FUND_UI_OFFSHORE: 'Fund unit interests – offshore',
  PRODUCTION_PAYMENT: 'Production payment',
  OVERRIDE_ROYALTY_INTEREST: 'Overriding royalty interest',
  ROYALTY_INTEREST: 'Royalty interest',
  NET_PROFIT_INTEREST: 'Net profits Interest',
  WORKING_INTEREST: 'Working interest',
  INVESTMENT_INSTRUMENTS_OTHER: 'Other'
});